import AboutFinalCta from "../components/about/AboutFinalCta";
import AboutFounder from "../components/about/AboutFounder";
import AboutHero from "../components/about/AboutHero";
import AboutStory from "../components/about/AboutStory";
import AboutSupportSystem from "../components/about/AboutSupportSystem";
import AboutTrustSection from "../components/about/AboutTrustSection";
import AboutVisionMission from "../components/about/AboutVisionMission";
import SeoHead from "../components/common/SeoHead";
import { aboutPageData } from "../data/aboutData";

function AboutPage() {
  return (
    <>
      <SeoHead
        title={aboutPageData.seo.title}
        description={aboutPageData.seo.description}
        path="/about"
        keywords={[
          "about nextera abroad",
          "study abroad mentors",
          "international education counselling team",
          "student first overseas guidance"
        ]}
      />

      <AboutHero />
      <AboutStory />
      <AboutFounder />
      <AboutVisionMission />
      <AboutSupportSystem />
      <AboutTrustSection />
      <AboutFinalCta />
    </>
  );
}

export default AboutPage;
